import styles from './style.css';
import {MAIN_EMAIL, MAIN_PHONE, SECONDARY_PHONE} from "../../constants/general";
const FooterComponent = () => {
    return <footer className={styles.footer}>
        <div>
            <span>17 rue Louise Dory</span>
            <span>93230</span>
            <span>Romainville</span>
        </div>
        <div>
            <span>{MAIN_PHONE}</span>
            <span>{SECONDARY_PHONE}</span>
            <span>{MAIN_EMAIL}</span>
        </div>
    </footer>
}

export default FooterComponent;